import React from 'react'
import { ISellerTableProductItem } from '../../../../../modules/API/Seller/models/tableData'
import SellerBodyBlock from './SellerBodyBlock'
import { ISellerChangeOrderProps } from '../types/handlerChangeOrder'

type Props = {
  list: ISellerTableProductItem[],
  handleChangeOrder: (props: ISellerChangeOrderProps) => void
  openFreightCompanyModal: (id: string, growerID: number, customerID: number, freightCompanyID: number, qty: number, remark: string) => void
  openRemarkModal: (id: string, growerID: number, customerID: number, freightCompanyID: number, qty: number, remark: string) => void
  handleSelectProduct: (item: ISellerTableProductItem) => void
  openTahazitRemarkModal: (id: string, growerID: number, customerID: number, qty: number, tahazitRemark: string) => void
}

const SellerBody = ({
  list,
  handleChangeOrder,
  openFreightCompanyModal,
  openRemarkModal,
  handleSelectProduct,
  openTahazitRemarkModal
}: Props) => {
  return (
    <tbody>
      {
        list.map((item) => (
          <SellerBodyBlock
            key={item.id}
            {...item}
            handleChangeOrder={handleChangeOrder}
            openFreightCompanyModal={openFreightCompanyModal}
            openRemarkModal={openRemarkModal}
            handleSelectProduct={handleSelectProduct}
            item={item}
            openTahazitRemarkModal={openTahazitRemarkModal}
          />
        ))
      }
    </tbody>
  )
}

export default SellerBody
